import styled from 'styled-components';
import { InputAutocomplete } from 'timeone-components';
import media from 'styled-media-query';

const SquarredInputAutocomplete = styled(InputAutocomplete)`
  &.tol-input-container {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    border: 0.0625rem ${({ theme }) => theme.colors.primary} solid;
    display: flex;
    padding: 0;
    position: relative;
    ${media.greaterThan('large')`
      margin: 0.5rem 0 1.5rem;
      width: calc(50% - 1rem);
    `}
    ${media.lessThan('large')`
      margin: 0.5rem auto 1.5rem;
      width: calc(100% - 2.5rem);
    `}

    &:focus {
      background-color: rgba(232, 232, 232, 0.4);
      outline: none;
    }

    .tol-input {
      margin: 0;
      padding: 0.125rem 0;

      .to-defaultinput__option-label {
        display: none;
      }

      & > span {
        font-size: 0.75rem;
        left: 2.25rem;
        text-transform: none;
        top: 0.875rem;

        &.active {
          visibility: hidden;
        }
      }

      .autocomplete__control {
        border: none;
        font-size: 0.75rem;
        margin: 0;
        padding: 0;

        input {
          padding-left: 1.75rem !important;
        }

        .autocomplete__single-value {
          margin-left: 2.25rem;
        }
      }

      &::before,
      &::after {
        content: none;
      }
    }

    & > span {
      left: 0.25rem;
      margin: 0;
      position: absolute;
      top: calc(100% + 0.25rem);
    }
  }
`;

export default SquarredInputAutocomplete;
